import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { CustomValidator } from 'src/app/shared/directive/custom-validator';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { PATH_ROUTING } from '../../../../../../shared/enums/routing-enums';
import { SrmService } from '../../../../../../shared/service/srm.service';

@Component({
  selector: 'app-create-edit-application-link',
  templateUrl: './create-edit-application-link.component.html',
  styleUrls: ['./create-edit-application-link.component.scss']
})
export class CreateEditApplicationLinkComponent implements OnInit {


  @ViewChild('fileInput') fileInput;
  public sectionId: number;
  public listApp: any[] = [];
  public title: string;
  public formGroup: FormGroup;
  public name: string;
  public url: string;
  public description: string;
  public urlIcon: string | ArrayBuffer;
  public fileIcon: any;
  public imgDefault = '/assets/images/icons/img_default.png';
  public isEdit = false;
  public icon: any;
  public appId: number;
  public errorMessage = '';
  constructor(
    private spinner: Spinner,
    private router: Router,
    private toastr: ToastrService,
    private srmService: SrmService,
    private activatedRouter: ActivatedRoute
  ) { }

  ngOnInit() {
    if (this.router.url.search('edit') !== -1) {
      this.isEdit = true;
    }
    this.activatedRouter.params.subscribe(res => {
      if (res.id) {
        this.appId = res.id;
        this.getApplicationById(this.appId);
      }
      this.sectionId = res.sectionId;
    });
    this.initForm();
  }

  public initForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(this.name, [CustomValidator.required, CustomValidator.maxLength(50)]),
      url: new FormControl(this.url, [CustomValidator.required, CustomValidator.url]),
      description: new FormControl(this.description, [CustomValidator.required, CustomValidator.maxLength(512)])
    });
  }
  public onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (file.size > 10485760) {
        this.toastr.error(
          MESSAGE_TOAST.ERROR_CHOOSE_FILE_DOC_SIZE
        );
        return;
      }
      if (file.name.split('.')[file.name.split('.').length - 1] === 'svg') {
        this.toastr.error(
          MESSAGE_TOAST.FILE_TYPE_WRONG
        );
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const url = ((event.target) as FileReader).result;
        this.fileIcon = file;
        this.urlIcon = url;
        this.errorMessage = '';
        this.fileInput.nativeElement.value = '';
      };
    }
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  public submit() {
    if (this.formGroup.invalid) {
      this.markFormGroupTouched(this.formGroup);
      return;
    }

    if (this.urlIcon === undefined || this.urlIcon === '') {
      this.errorMessage = 'No file chosen';
      return;
    }

    const requestModel = {
      id: this.appId,
      title: this.formGroup.controls['name'].value,
      url: this.formGroup.controls['url'].value,
      description: this.formGroup.controls['description'].value,
      sectionId: this.sectionId,
      icon: this.icon
    };
    this.spinner.show();
    if (!this.isEdit) {
      this.srmService.addApplicationLinks(requestModel, this.fileIcon).subscribe((res: any) => {
        this.spinner.hide();
        if (res.status === 200) {
          this.toastr.success(MESSAGE_TOAST.ADD_APPLICATION_LINK);
          this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'application-link', this.sectionId]);
        }
      });
    } else {
      this.srmService.updateApplicationLink(requestModel, this.fileIcon).subscribe((res: any) => {
        this.spinner.hide();
        if (res.status === 200) {
          this.toastr.success(MESSAGE_TOAST.UPDATE_APPLICATION_LINK);
          this.isEdit = false;
          this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'application-link', this.sectionId]);
        }
      });
    }
  }

  public getApplicationById(id) {
    this.spinner.show();
    this.srmService.getApplicationLinkById(id).subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        this.name = res.data.title;
        this.appId = res.data.id;
        this.url = res.data.url;
        this.description = res.data.description;
        this.icon = res.data.icon;
        this.urlIcon = res.data.icon.resourceUrl;
        this.initForm();
      }
    }, (err) => {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_SECTION]);
    });
  }

  public removeIcon() {
    this.urlIcon = '';
    this.fileIcon = '';
    this.errorMessage = 'No file chosen';
  }


}
